// Module
var code = "<div class=\"select\" id=\":elementId\"> <select class=\"\"></select> </div> ";
// Exports
export default code;